"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Input = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _constants = require("../../constants");
var _InputMixin = require("../../mixins/components/InputMixin");
var _FormControl = require("../FormControl/FormControl");
/**
 * @since 1.3.0
 */
var Input = /*#__PURE__*/(0, _styledComponents.default)(_FormControl.FormControl).withConfig({
  displayName: "Input",
  componentId: "c11n-8-107-0__sc-4ry0fw-0"
})(["", ""], _InputMixin.InputMixin);
exports.Input = Input;
Input.displayName = 'Input';
Input.propTypes = {
  /**
   * Used for
   * [autofill](https://developers.google.com/web/updates/2015/06/checkout-faster-with-autofill).
   */
  autoComplete: _propTypes.default.string,
  /**
   * Determines the size of the input.
   */
  size: _propTypes.default.oneOf(Object.values(_constants.INPUT_SIZES)),
  /**
   * Displays the input in an error state. Can also be inherited from a FormField parent.
   */
  error: _propTypes.default.bool,
  /**
   * The HTML input type.
   * @ignore
   */
  type: _propTypes.default.string,
  /**
   * Inputs are fluid by default which means they stretch to fill the entire width of their
   * container. When `fluid="false"`, the inputs's width is set to `auto`.
   */
  fluid: _propTypes.default.bool,
  /**
   * Indicates the input is required. Can also be inherited from a FormField parent.
   */
  required: _propTypes.default.bool,
  /**
   * Displays the input in a disabled state. Can also be inherited from a FormField parent.
   */
  disabled: _propTypes.default.bool,
  /**
   * Displays the input in a read-only state. Can also be inherited from a FormField parent.
   *
   * @since 8.27.0
   */
  readOnly: _propTypes.default.bool
};
Input.defaultProps = {
  size: _constants.INPUT_SIZES.md,
  type: 'text',
  fluid: true
};

/** @component */